import { useCallback, useEffect, useState } from 'react';
import axiosInstance from 'src/common/axiosInstance';
import { clearRequestCache, dedupedRequest } from 'src/common/requestCache';

// AUTO-WA-39 quick replies: saved answers shared by the whole organisation.
const base = (workspaceId) => `/workspaces/${workspaceId}/quick-replies`;

const quickReplyApi = {
  list: (workspaceId) => dedupedRequest(`quick-replies:${workspaceId}`, () => axiosInstance.get(base(workspaceId)).then((r) => r.data), { ttlMs: 20000 }),
  create: (workspaceId, body) => axiosInstance.post(base(workspaceId), body).then((r) => { clearRequestCache('quick-replies:'); return r.data.data; }),
  update: (workspaceId, id, body) => axiosInstance.put(`${base(workspaceId)}/${id}`, body).then((r) => { clearRequestCache('quick-replies:'); return r.data.data; }),
  remove: (workspaceId, id) => axiosInstance.delete(`${base(workspaceId)}/${id}`).then(() => clearRequestCache('quick-replies:')),
  used: (workspaceId, id) => axiosInstance.post(`${base(workspaceId)}/${id}/used`).catch(() => null),
};

export default quickReplyApi;

export function useQuickReplies(workspaceId) {
  const [state, setState] = useState({ loading: true, items: [], canManage: false, error: '' });
  const load = useCallback(async () => {
    if (!workspaceId) { setState({ loading: false, items: [], canManage: false, error: '' }); return; }
    setState((current) => ({ ...current, loading: true, error: '' }));
    try {
      const data = await quickReplyApi.list(workspaceId);
      setState({ loading: false, items: data.data || [], canManage: Boolean(data.can_manage), error: '' });
    } catch {
      setState((current) => ({ ...current, loading: false, error: 'Quick replies couldn’t be loaded.' }));
    }
  }, [workspaceId]);
  useEffect(() => { load(); }, [load]);
  return [state, load];
}

export const matchReplies = (items, query) => {
  const needle = String(query || '').trim().toLowerCase().replace(/^\//, '');
  if (!needle) return items;
  return items.filter((item) => [item.shortcut, item.title, item.body].some((value) => String(value || '').toLowerCase().includes(needle)));
};
